import {NumberField} from "./number";

export class IntegerField extends NumberField {
  //
}

customElements.define("cx-int-field", IntegerField);
